import api from '@/api/fetchClient'

export default {
  getExpenses(params = {}) {
    let url = 'expenses'
    const queryParams = []

    if (params.search) {
      queryParams.push(`search=${encodeURIComponent(params.search)}`)
    }
    if (params.status) {
      queryParams.push(`status=${encodeURIComponent(params.status)}`)
    }
    if (params.vendorId) {
      queryParams.push(`vendorId=${params.vendorId}`)
    }

    if (queryParams.length > 0) {
      url += '?' + queryParams.join('&')
    }

    return api.get(url, { authorized: true })
  },

  getExpenseById(id) {
    return api.get(`expenses/${id}`, { authorized: true })
  },

  createExpense(payload) {
    return api.post('expenses', payload, { authorized: true })
  },

  updateExpense(id, payload) {
    return api.put(`expenses/${id}`, payload, { authorized: true })
  },

  deleteExpense(id) {
    return api.delete(`expenses/${id}`, { authorized: true })
  },

  getUnpaidExpenses(vendorPartyId) {
    return api.get(`expenses/unpaid/${vendorPartyId}`, { authorized: true })
  }
}
